export default __webpack_public_path__ + "static/media/illustration-study-3-m@2x.8d02cc48.webp";